// extracted by mini-css-extract-plugin
export default {"card":"Card_card__tKdkS","cardBody":"Card_cardBody__4IxAP","iconStyle":"Card_iconStyle__rFm8J","cardHeadingText":"Card_cardHeadingText__fZ6Vb"};